module.exports = __webpack_public_path__ + "img/cm3.0cb95869.png";